import { Component } from '@angular/core';

@Component({
  selector: 'app-dot-notification-demo',
  templateUrl: './dot-notification-demo.component.html',
})
export class DotNotificationDemoComponent {}
